import React, { useEffect, useState } from 'react';
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import usePermission from '../../config/permissions';
import { AssignedTasks, MyTasks } from './TaskManagement';
import { AssignTask, TaskChatModel } from './TaskComponents';
import { Eye, Filter, SearchBig } from '../AllSvg';
import { DateRangePicker, handleErrorToast } from '../CustomFunctions';
import { BASE_URL } from '../../config/axios';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../Date';

const TasksPage = () => {

    const [startdate, setStartDate] = useState("");
    const [enddate, setEndDate] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    const [asignee, setAsignee] = useState("");
    const [tasksList, settasksList] = useState([]);
    const [filteredtasksList, setFilteredtasksList] = useState([]);

    const handleSearch = () => {
        let filteredData = tasksList;


        if (asignee) {
            const lowercaseSelectedName = asignee?.toLowerCase();
            filteredData = filteredData.filter((employee) => {
                const assigneeNameMatch = employee.concern_person?.toLowerCase().includes(lowercaseSelectedName);

                const assigneeEmailMatch = employee.assigned_by?.toLowerCase().includes(lowercaseSelectedName);

                const title = employee.task?.toLowerCase().includes(lowercaseSelectedName);

                const description = employee.feedback?.toLowerCase().includes(lowercaseSelectedName);

                return (
                    assigneeNameMatch || assigneeEmailMatch || title || description
                );
            });
        }

        if (selectedStatus) {
            filteredData = filteredData.filter(
                (employee) => employee.task_status === selectedStatus
            )
        }

        if (startdate !== "" && enddate !== "") {
            filteredData = filteredData.filter(
                (employee) =>
                    employee.assigndate >= startdate && employee.assigndate <= enddate
            );
        } else if (startdate !== "") {
            filteredData = filteredData.filter(
                (employee) => employee.assigndate >= startdate
            );
        } else if (enddate !== "") {
            filteredData = filteredData.filter(
                (employee) => employee.assigndate <= enddate
            );
        }



        setFilteredtasksList(filteredData);
    };

    useEffect(() => {
        handleSearch();

    }, [
        selectedStatus,
        tasksList,
        asignee,
        startdate,
        enddate,
    ]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [toggleState, setToggleState] = useState("1");
    const getSelectedTitle = () => {
        switch (toggleState) {
            case "1":
                return 'My Tasks';
            case "2":
                return 'Assigned Tasks';
            // case 3:
            //     return 'Custom Expense Excel';
            default:
                return 'My Tasks';
        }
    };
    const getAlltasksList = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                toggleState === "1"
                    ? `${BASE_URL}/task/taskassignby/${sessionStorage.getItem("email")}/`
                    : toggleState === "2" ? `${BASE_URL}/task/taskassignto/${sessionStorage.getItem("email")}/`
                        : `${BASE_URL}/task/task/`
            );

            settasksList(res.data);


        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    useEffect(() => {
        getAlltasksList();
    }, [toggleState]);

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const taskUrl = "/" + urlParts[3] + "/task/";
    const ViewTaskDetails = (i) => {
        navigate(taskUrl + i + '/', { state: { i } });
    };


    return (
        <>
            <Dashboardnavbar name={getSelectedTitle()} url="Tickets Managment" />

            {/* <div className="bloc-tabss2  wfm-margin">
                <button
                    className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                    onClick={() => setToggleState(1)}
                >
                    My Tasks
                </button>
                < button
                    className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                    onClick={() => setToggleState(2)}
                >
                    Assigned Task
                </button>

            </div> */}

            <div>
                <>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                    <div className="content-tabs">
                        <div className="attendance-subcont">
                            <div className="field-cont">
                                <div title=' Date Range' className="field-cont-div ">

                                    <DateRangePicker startDate={startdate} endDate={enddate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                        setStartDate(start);
                                        setEndDate(end);

                                    }} />
                                    <hr className="field-cont-hr" />
                                </div>
                                <div className="field-cont-div">
                                    <Filter />
                                    <select
                                        className="attendance-input-field width-10vw   date-field"
                                        type="text"
                                        value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="pending">Pending</option>
                                        <option value="completed">Completed</option>
                                        {/* {status_list.map((status) => (
                                    <option value={status}>{status}</option>
                                ))} */}
                                    </select>
                                    <hr className="field-cont-hr" />

                                </div>
                                <div className="field-cont-div">
                                    <Filter />
                                    <select
                                        className="attendance-input-field width-10vw   date-field"
                                        type="text"
                                        value={toggleState}
                                        onChange={(e) => setToggleState(e.target.value)}
                                    >
                                        <option value="1">Assigned By Me </option>
                                        <option value="2">Assigned To Me</option>
                                        <option value="3">Raised Tasks</option>
                                        {/* {status_list.map((status) => (
                                    <option value={status}>{status}</option>
                                ))} */}
                                    </select>
                                    <hr className="field-cont-hr" />

                                </div>
                                <div className="field-cont-div-svg">
                                    <SearchBig />
                                    <input
                                        className="attendance-input-field width-15vw  "
                                        placeholder="By Task Name, Emp & Description"
                                        type="text"
                                        value={asignee}
                                        onChange={(e) => setAsignee(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <AssignTask />
                            </div>
                        </div>
                        <div className='table-box scroll-container-table'>
                            <table className="table-css width-100vw" style={{ minHeight: "60vh" }}>
                                <thead className="table-heading">
                                    <tr className="custom-table-head-tr ">
                                        <th className="table-heading-text text-left-sr">Sr no.</th>
                                        <th className="table-heading-text">Assigned {toggleState === "2" ? "By" : "To"}</th>
                                        <th className="table-heading-text">Task</th>
                                        <th className="table-heading-text">Description</th>
                                        <th className="table-heading-text">Assigned Date</th>
                                        <th className="table-heading-text">Due date</th>
                                        <th className="table-heading-text">Completed date</th>
                                        <th className="table-heading-text">Chat History</th>
                                        <th className="table-heading-text">Priorty</th>
                                        <th className="table-heading-text">Status</th>
                                        <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <div className="spinner"></div> //buffering logic
                                ) : (
                                    <tbody>
                                        {filteredtasksList
                                            .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
                                            .sort((a, b) => a.priority - b.priority)
                                            .map((i, index) => (
                                                <React.Fragment key={index}>
                                                    <tr className="custom-table-head-td">
                                                        <td className="table-body text-left-sr">{index + 1}.</td>
                                                        <td className="table-body">
                                                            {i.concern_person}
                                                        </td>
                                                        <td className="table-body">{i.task}</td>
                                                        <td className="table-body">
                                                            {/* <div dangerouslySetInnerHTML={createMarkup(i.feedback)} /> */}
                                                            {i.feedback}
                                                        </td>
                                                        <td className="table-body">{formatDate(i.assigndate)}</td>
                                                        <td className="table-body">{formatDate(i.due_date)}</td>
                                                        <td className="table-body">{i.completed_date ? formatDate(i.completed_date) : "-"}</td>
                                                        <td className="table-body">
                                                            <TaskChatModel i={i.id} getAllTasks={getAlltasksList} clientemail={i.concern_person_email}
                                                                clientname={i.concern_person}
                                                                name={i.task}
                                                                status={i.task_status}
                                                                receiver={i.assign_by_email}
                                                                receiver_name={i.assigned_by_name}
                                                            // productname={i.ticket_for}
                                                            />
                                                        </td>
                                                        {/* <td className="table-body">
                                                    {i.priority ? handlePriority(i.priority) : '-'}
                                                </td> */}
                                                        <td className="table-body">{i.priority}</td>
                                                        <td className="table-body">{i.task_status}</td>
                                                        <td className=" table-body flex-row  text-right" style={{ justifyContent: 'right' }}>
                                                            <button
                                                                className=""
                                                                title="View Ticket Details"
                                                                onClick={() => ViewTaskDetails(i.id)}
                                                            >
                                                                <Eye />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

export default TasksPage;